exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-dialog .order-container[data-v-1bbdb0fb]{padding:0 20px}.order-dialog .order-container .el-col[data-v-1bbdb0fb]{line-height:38px}\n", ""]);

// exports
